/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { ReactNode } from "react";
import { Box } from "@mui/material";
import { useCarousel } from "./CarouselProvider";

export type CarouselSlidesProps = {
  children: ReactNode;
};

export const CarouselSlides = ({ children }: CarouselSlidesProps) => {
  const { carouselRef } = useCarousel();

  return (
    <Box
      sx={{
        overflow: "hidden",
      }}
      ref={carouselRef}
    >
      <Box
        sx={{
          display: "flex",
          touchAction: "pan-y pinch-zoom",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
